import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
//import { useToast } from '../components/ToastContext';
// Icons
import { VscCheck } from "react-icons/vsc";
import { BiEdit } from 'react-icons/bi';
import { VscGithubAction } from "react-icons/vsc";
import { VscMail } from "react-icons/vsc";
import { VscOpenPreview } from "react-icons/vsc";
import { MdOutlinePayments } from "react-icons/md";
import { GetAgoTime } from '../components/getAgoTime';
import { CiBookmarkCheck, CiBookmark } from "react-icons/ci";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import { BsPersonWorkspace } from "react-icons/bs";
import { IoBusinessOutline, IoDocumentTextOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
//page links       
import Statusbar from '../master_root/statusbar';
import './jobs-list.css';
export default function Joblist() {
  const [Jobtasks, setJobtasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [guid, setGuid] = useState("");
  const [loginisOpen, setLoginIsOpen] = useState(false);
  //Jobtasks
  useEffect(() => {
    const fetchJobtasks = async () => {
      try {
        const q = query(
          collection(db, "postdata"),
          where("status", "==", true)
        );
        const querySnapshot = await getDocs(q);

        const JobtasksList = await Promise.all(
          querySnapshot.docs.map(async doc => {
            const jobData = { id: doc.id, ...doc.data() };

            // Fetch corresponding company data
            const cq = query(
              collection(db, "companys"),
              where("uid", "==", jobData.companysuid),
              where("status", "==", true)
            );
            const companysSnapshot = await getDocs(cq);
            const companyData = companysSnapshot.docs.map(cdoc => ({
              id: cdoc.id,
              ...cdoc.data()
            }))[0]; // Assuming only one company per job

            return {
              ...jobData,
              company: companyData || null
            };
          })
        );

        setJobtasks(JobtasksList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching Jobtasks:", error);
        setIsLoading(false);
      }
    };

    fetchJobtasks();
  }, []);


  const status_change = async (uid) => {
    try {
      const q = query(collection(db, "postdata"), where("uid", "==", uid), where("status", "==", true),);
      const snapshot = await getDocs(q);

      snapshot.forEach(async (docSnap) => {
        const currentData = docSnap.data();
        const newVisibility = !currentData.visibility;

        // Update Firestore
        await updateDoc(doc(db, "postdata", docSnap.id), {
          visibility: newVisibility
        });

        // Update local state
        setJobtasks((prevTasks) =>
          prevTasks.map((task) =>
            task.uid === uid ? { ...task, visibility: newVisibility } : task
          )
        );
      });
    } catch (error) {
      console.error("Error updating visibility:", error);
    }
  };

  return (
    <>
        <Statusbar data={'Job list'}/>
           <div className='app_header_height'></div>
 
    <div className="container_roots">
    <div className="container_size"> 
      <div className="post-container">
        <div className="post_div">
        <b className='post-header'>Jobs list</b>
        <br/><br/>
        <div className="Tasks-grid">
          {isLoading ? (
            <Lodinging />
          ) : (
            Jobtasks.map((Jobtask, index) => (
              <div
                key={index}
                className="Tasks-items"
              >

                {Jobtask.company && (
                  <div className="company-hiring" onClick={() => navigate(`/${Jobtask.slug}`)}>
                    <div className='hir-div'>
                      <div className="title-text">{Jobtask.jobcategories}</div> 
                    </div>              
                  </div>
                )}
                <div className='job-info-body' >
                  <div className='job-info'>

                    <table className='experience-table'>
                      <tr><td>
                        <LuBriefcaseBusiness className='job_biz_icon' />
                      </td>
                        <td>
                          <a> {Jobtask.experience_min + "-" + Jobtask.experience_max} Yrs</a>
                        </td>
                      </tr>

                      <tr><td>
                        <MdOutlinePayments className='job_biz_icon' />
                      </td>
                        <td>
                          <a className='job_biz_text'> {Jobtask.currency_symbol + "" + Jobtask.budget + "/- " + Jobtask.budgetpackage}</a>
                        </td>
                      </tr>
                      <tr><td>
                        <CiLocationOn className='job_biz_icon' />
                      </td>
                        <td>
                          <a className='job_biz_text'>{Jobtask.city}</a>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div className='job-info'>
                    <table className='experience-table'>
                      <tr><td>
                        <IoDocumentTextOutline className='job_biz_icon' />
                      </td>
                        <td>
                          <a className='job_biz_text'> Greetings: {Jobtask.title}</a>
                        </td>
                      </tr>
                      <tr><td>
                        <BsPersonWorkspace className='job_biz_icon' />
                      </td>
                        <td>
                          <a className='job_biz_text'>{Jobtask.skills}</a>
                        </td>
                      </tr>
                      <tr><td>
                        <VscCheck className='job_biz_icon' />
                      </td>
                        <td className='job_biz_text'>
                        <b    >
                            Status: {Jobtask.status? ' Activate' : ' Deactivate'}
                          </b>
                        </td>
                      </tr>
                      <tr><td>
                        <BiEdit className='job_biz_icon' />
                      </td>
                        <td  >
                          <b
                            className={`status-ui ${Jobtask.visibility ? 'visible' : 'closed'}`}
                            onClick={() => status_change(Jobtask.uid)}
                          > 
                              {Jobtask.visibility ? 'Visible' : 'Close'}
                          </b>
                          <a>
                            {' '}
                            {new Date(Jobtask.update_date_time.seconds * 1000).toLocaleString('en-GB', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            }).toUpperCase()}
                          </a>
                        </td>
                      </tr>
                  
                    </table>
                  </div>
                </div>
                <div className='job-save-div' >
                  <div className='date-lable'>
                    {new Date(Jobtask.date_time.seconds * 1000).toLocaleString('en-GB', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    }).toUpperCase()} </div>
                  <div className='summarylistdiv'>
                    <div className='save_note' title='Applied'>
                      <VscMail className='save_icon' />
                      <div className='save_text'>{Jobtask.read}</div>
                    </div>
                    <div className='save_note' title='Read'>
                      <VscOpenPreview className='save_icon' />
                      <div className='save_text'>{Jobtask.read}</div>
                    </div>
                    <div className='save_note' title='Save'>
                      <CiBookmark className='save_icon' />
                      <div className='save_text'>Save</div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        </div>
        <div className="post_updates">
        <b className='post-header'>Closed Ads</b>
         
        </div>
        </div>
        </div>
    </div>
       </>
  );
}
